import React, { useEffect } from "react";
import "./Clients.css";
import "../../Pages/LandingPage/LandingPage.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import c1 from "../../Assets/svgs/C1.svg";
import c2 from "../../Assets/svgs/C2.svg";
import c3 from "../../Assets/svgs/C3.svg";
import c4 from "../../Assets/svgs/c4.svg";
import c5 from "../../Assets/svgs/c5.webp";
import $ from "jquery";
import "slick-carousel";
import { Container } from "react-bootstrap";

function Clients() {
  useEffect(() => {
    const slickContainer = document.querySelector(".customer-logos");

    if (slickContainer && $) {
      $(slickContainer).slick({
        dots: false,
        infinite: true,
        autoplay: false,
        speed: 100,
        slidesToShow: 5,
        slidesToScroll: 1,
      });
    }

    return () => {
      if (slickContainer) {
        $(slickContainer).slick("unslick");
      }
    };
  }, []);

  return (
    <section id="ourclientsub" data-stellar-background-ratio="0.5">
      <Container>
        <div className="customer-logos slider ">
          <div className="slide" >
            <img
              src={c1}
              id="logo1"
              alt="Boost board digital signage client BRT Peshawar"
            />
          </div>

          <div className="slide">
            <img
              src={c2}
              id="logo2"
              alt="Boost board digital signage client Shifa International Hospital"
            />
          </div>
          <div className="slide">
            <img
              src={c3}
              id="logo3"
              alt="Boost board digital signage client The World Bank"
            />
          </div>
          <div className="slide">
            <img
              src={c4}
              id="logo4"
              alt="Boost board digital signage client Dominos"
            />
          </div>
          <div className="slide">
            <img
              src={c5}
              id="logo5"
              alt="Boost board digital signage client POF"
            />
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Clients;
